module.exports = __webpack_public_path__ + "saira-light-webfont.92bdf27fad86ae657507.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-light-webfont.woff2
// module id = ../../../../../src/assets/fonts/saira-light-webfont.woff2
// module chunks = styles